import React from 'react';

import {Button, Text} from '@albert-io/atomic';
import {EmptyIllustration, EmptyState} from 'client/TeacherDashboard/components/EmptyState';
import {history} from 'client/history';

// Product wants one identical empty state across the cross-class and class-scoped Subjects views
// (Figma 7462-48516), without the getting-started module the classroom EmptyState wrapper adds.
export const SubjectsEmptyState = () => (
  <EmptyState
    action={
      <Button roundness='pill' onClick={() => history.pushState(null, '/subjects')}>
        Browse Subjects
      </Button>
    }
    illustration={
      <EmptyIllustration
        badgeClassName='background-clementine-subtle content-clementine'
        icon='books'
      />
    }
  >
    <div className='gap-x1 flex flex-col'>
      <Text as='div' size='l'>
        No Class Subjects
      </Text>
      <Text as='div' className='max-w-[380px]' color='tertiary'>
        No subjects are available for students to practice. Visit the subject library to assign or
        open practice.
      </Text>
    </div>
  </EmptyState>
);
